import css from 'styled-jsx/css';

export const ImageGalleryControlButtonsStyles = css`
  /* Block: Main container for control buttons */
  .image-gallery-control-buttons {
    position: relative;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  /* Ensure buttons have pointer events */
  .image-gallery-control-buttons button {
    pointer-events: auto;
  }

  /* Element: Individual control button */
  .image-gallery-control-buttons__button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: rgba(128, 128, 128, 0.8);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    pointer-events: auto;
    transition: all 0.2s ease;
  }

  /* Element modifiers: Button positioning */
  .image-gallery-control-buttons__button--left {
    left: 16px;
  }

  .image-gallery-control-buttons__button--right {
    right: 16px;
  }

  /* Element modifiers: Button variants */
  .image-gallery-control-buttons__button--transparent {
    background-color: rgba(128, 128, 128, 0.8);
  }

  .image-gallery-control-buttons__button--opaque {
    background-color: rgba(100, 100, 100, 0.9);
  }

  .image-gallery-control-buttons__button--smallAndTransparent {
    width: 40px;
    height: 40px;
    background-color: rgba(128, 128, 128, 0.7);
  }

  .image-gallery-control-buttons__button--connect {
    width: 32px;
    height: 32px;
    background-color: rgba(128, 128, 128, 0.8);
  }

  /* Element: Button icons */
  .image-gallery-control-buttons__button .icon {
    color: white;
    font-size: 16px;
  }

  .image-gallery-control-buttons__button .icon.i-gallery.csicon-arrow_right {
    margin-left: 0;
  }

  /* Hover states */
  .image-gallery-control-buttons__button:hover {
    background-color: rgba(100, 100, 100, 0.9);
    transform: translateY(-50%) scale(1.05);
  }

  /* Focus states for accessibility */
  .image-gallery-control-buttons__button:focus {
    outline: 2px solid white;
    outline-offset: 2px;
  }

  /* Active states */
  .image-gallery-control-buttons__button:active {
    transform: translateY(-50%) scale(0.95);
  }

  /* Disabled states */
  .image-gallery-control-buttons__button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .image-gallery-control-buttons__button {
      width: 44px;
      height: 44px;
    }

    .image-gallery-control-buttons__button--left {
      left: 12px;
    }

    .image-gallery-control-buttons__button--right {
      right: 12px;
    }

    .image-gallery-control-buttons__button--smallAndTransparent {
      width: 36px;
      height: 36px;
    }

    .image-gallery-control-buttons__button--connect {
      width: 28px;
      height: 28px;
    }

    .image-gallery-control-buttons__button .icon {
      font-size: 14px;
    }
  }

  @media (max-width: 480px) {
    .image-gallery-control-buttons__button {
      width: 40px;
      height: 40px;
    }

    .image-gallery-control-buttons__button--left {
      left: 8px;
    }

    .image-gallery-control-buttons__button--right {
      right: 8px;
    }

    .image-gallery-control-buttons__button--smallAndTransparent {
      width: 32px;
      height: 32px;
    }

    .image-gallery-control-buttons__button--connect {
      width: 24px;
      height: 24px;
    }

    .image-gallery-control-buttons__button .icon {
      font-size: 12px;
    }
  }
`;
